import { useMemo } from 'react';
import { IntlProvider } from 'react-intl';

import Router from 'components/Router';
import { config } from 'config';
import { ApartmentsFilterProvider } from 'context/apartmentsFilterContext';
import { ContactModalProvider } from 'context/contactModalContext';
import { DataProvider } from 'context/dataContext';
import { NavigationProvider } from 'context/navigationContext';
import { SettingsProvider } from 'context/settingsContext';
import { TranslationProvider } from 'context/translationContext';
import en from 'locale/en.json';
import pl from 'locale/pl.json';

import styles from './styles.module.scss';

const importMessages = (locale: string) => {
  switch (locale) {
    case 'pl':
      return pl;
    case 'en':
      return en;
    default:
      return pl;
  }
};

const App = () => {
  const { locale } = config;

  const messages = useMemo(() => importMessages(locale), []);

  return (
    <IntlProvider locale={locale} messages={messages}>
      <TranslationProvider>
        <DataProvider>
          <NavigationProvider>
            <ContactModalProvider>
              <ApartmentsFilterProvider>
                <SettingsProvider>
                  <div className={styles.container}>
                    <div className={styles.wrapper}>
                      <Router />
                    </div>
                  </div>
                </SettingsProvider>
              </ApartmentsFilterProvider>
            </ContactModalProvider>
          </NavigationProvider>
        </DataProvider>
      </TranslationProvider>
    </IntlProvider>
  );
};

export default App;
